import * as Yup from 'yup';
export const QualifyFormSchema = Yup.object().shape({
  existing: Yup.number()
    .typeError('مقدار عددی وارد نمایید')
    .required('موجودی اجباری می باشد'),
  existing_units: Yup.string(),
});
